export default __webpack_public_path__ + "static/media/image13.e5ec4aee.jpg";